import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-header p-d-flex" }
const _hoisted_2 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = {
  id: "inbound-form",
  class: "p-fluid p-formgrid p-grid p-mt-4 p-mx-2 kn-flex-0"
}
const _hoisted_5 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_9 = { class: "p-float-label " }
const _hoisted_10 = {
  for: "source",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_12 = { class: "p-float-label " }
const _hoisted_13 = {
  for: "source",
  class: "kn-material-input-label"
}
const _hoisted_14 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = {
  for: "target",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_TableAssociator = _resolveComponent("TableAssociator")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: _ctx.inboundRelationships,
      class: "p-datatable-sm kn-table p-ml-2",
      responsiveLayout: "stack",
      breakpoint: "960px",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
      globalFilterFields: _ctx.irDescriptor.globalFilterFields
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              placeholder: _ctx.$t('common.search')
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: _ctx.$t('common.name'),
          sortable: true
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "sourceTableName",
          header: _ctx.$t('metaweb.businessModel.sourceTable'),
          sortable: true
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('metaweb.physicalModel.sourceColumns'),
          sortable: true
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.createColumnString(slotProps.data.sourceColumns)), 1)
            ], 512), [
              [
                _directive_tooltip,
                _ctx.createColumnString(slotProps.data.sourceColumns),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "destinationTableName",
          header: _ctx.$t('metaweb.businessModel.targetTable'),
          sortable: true
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('metaweb.physicalModel.targetColumns'),
          sortable: true
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.createColumnString(slotProps.data.destinationColumns)), 1)
            ], 512), [
              [
                _directive_tooltip,
                _ctx.createColumnString(slotProps.data.destinationColumns),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: _ctx.irDescriptor.style.iconColumnStyle,
          class: "p-text-right"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Button, {
              label: _ctx.$t('common.add'),
              class: "p-button-link p-text-right",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.inboundDialogVisible = true))
            }, null, 8, ["label"])
          ]),
          body: _withCtx((slotProps) => [
            _createVNode(_component_Button, {
              icon: "pi pi-trash",
              class: "p-button-link",
              onClick: ($event: any) => (_ctx.deleteInbound(slotProps.data))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }, 8, ["value", "filters", "globalFilterFields"]),
    _createVNode(_component_Dialog, {
      class: "bsdialog",
      style: _ctx.bsDescriptor.style.bsDialog,
      visible: _ctx.inboundDialogVisible,
      modal: true,
      closable: false
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary kn-width-full" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.tabView.inbound')), 1)
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-text kn-button",
          label: _ctx.$t('common.cancel'),
          onClick: _ctx.closeDialog
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          label: _ctx.$t('common.create'),
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.createInbound
        }, null, 8, ["label", "disabled", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode("form", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_InputText, {
                id: "name",
                class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.dataSend.name.$invalid && _ctx.v$.dataSend.name.$dirty
                        }],
                modelValue: _ctx.v$.dataSend.name.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.dataSend.name.$model = $event)),
                modelModifiers: { trim: true },
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.dataSend.name.$touch())),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('metaweb.businessModel.inbound.name')) + " *", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.dataSend.name,
              additionalTranslateParams: { fieldName: _ctx.$t('metaweb.businessModel.inbound.name') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("span", _hoisted_9, [
              _createVNode(_component_Dropdown, {
                id: "source",
                class: ["kn-material-input", { 'p-invalid': _ctx.v$.dataSend.cardinality.$invalid && _ctx.v$.dataSend.cardinality.$dirty }],
                modelValue: _ctx.v$.dataSend.cardinality.$model,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.dataSend.cardinality.$model = $event)),
                optionLabel: "name",
                optionValue: "value",
                options: _ctx.irDescriptor.cardinality,
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.dataSend.cardinality.$touch()))
              }, null, 8, ["modelValue", "options", "class"]),
              _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('kpi.kpiDefinition.cardinalityTtitle')) + " *", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.dataSend.cardinality,
              additionalTranslateParams: { fieldName: _ctx.$t('kpi.kpiDefinition.cardinalityTtitle') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("span", _hoisted_12, [
              _createVNode(_component_Dropdown, {
                id: "source",
                class: "kn-material-input",
                modelValue: _ctx.rightElement,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.rightElement = $event)),
                options: _ctx.sourceBusinessClassOptions,
                optionLabel: "name",
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.alterTableToSimpleBound($event.value)))
              }, null, 8, ["modelValue", "options"]),
              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('metaweb.businessModel.inbound.sourceBc')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("span", _hoisted_15, [
              _createVNode(_component_InputText, {
                id: "target",
                class: "kn-material-input",
                modelValue: _ctx.businessModel.name,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.businessModel.name = $event)),
                disabled: true
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('metaweb.businessModel.inbound.targetBc')), 1)
            ])
          ])
        ]),
        _createVNode(_component_TableAssociator, {
          class: "kn-flex",
          sourceArray: _ctx.simpleRight,
          targetArray: _ctx.simpleLeft,
          useMultipleTablesFromSameSource: false,
          onDrop: _ctx.onDrop,
          onRelationshipDeleted: _ctx.onDelete
        }, null, 8, ["sourceArray", "targetArray", "onDrop", "onRelationshipDeleted"])
      ]),
      _: 1
    }, 8, ["style", "visible"])
  ], 64))
}